// ФТУЕ.7: inline-переводы через хук useTr(ru, en).
//
// Альтернатива JSON-локалям — пишем переводы прямо в JSX рядом с
// русским оригиналом. Удобно когда строк много и они «принадлежат»
// конкретному компоненту, а не общему словарю.
//
// Использование:
//   const t = useTr();
//   <h1>{t('Выбери язык', 'Choose your language')}</h1>
//   <p>{t('Нажми чтобы продолжить', 'Tap to continue')}</p>
//
// Реактивность: хук подписан на i18next.changeLanguage — при смене
// языка все компоненты, использующие useTr, перерисуются.
//
// ВАЖНО: возвращаемая функция стабильна по ссылке внутри одного
// рендера (useMemo по isEn). Без этого useCallback/useEffect, у
// которых tr в deps, зацикливались — Quests, Profile и др. экраны
// уходили в бесконечный re-fetch.

import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import i18n from './index';

export function useTr() {
  const { i18n: i18nInstance } = useTranslation();
  const isEn = i18nInstance.language === 'en';
  // Стабильная ссылка: пересоздаётся только при смене языка.
  return useMemo(
    () => (ru: string, en: string): string => isEn ? en : ru,
    [isEn]
  );
}

// Чистая функция без хука — для случаев когда нет React-контекста.
// При смене языка значение НЕ обновится без re-render.
export function tr(ru: string, en: string): string {
  return i18n.language === 'en' ? en : ru;
}
